import { execFile } from "node:child_process";

export function openBrowser(url: string): void {
	// Launching is best-effort — the URL is also printed as a manual fallback —
	// so pass a no-op callback to swallow ENOENT/spawn errors instead of leaving
	// them unhandled.
	const ignore = (): void => {};
	if (process.platform === "darwin") {
		execFile("open", [url], ignore);
	} else if (process.platform === "win32") {
		// cmd.exe splits an unquoted command line at &, truncating any URL with
		// query params and running the rest as commands. Caret-escape cmd
		// metacharacters and pass the line verbatim (the same recipe as the
		// `open` npm package) so `start` receives the full URL.
		const escaped = url.replace(/[&|<>^]/g, "^$&");
		execFile(
			"cmd.exe",
			["/d", "/s", "/c", "start", '""', escaped],
			{ windowsVerbatimArguments: true },
			ignore,
		);
	} else {
		execFile("xdg-open", [url], ignore);
	}
}
